import Flickity from 'flickity';
import 'flickity-imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
    var carouselElems = document.querySelectorAll('.carousel');
    for (let i = 0; i < carouselElems.length; i++) {
        const carouselElem = carouselElems[i];

        const cellCount = carouselElem.querySelectorAll('.carousel-cell').length;

        new Flickity(carouselElem, {
            wrapAround: true,
            pageDots: false,
            imagesLoaded: true,
            watchCSS: true,
            prevNextButtons: false
        });
    }
});